var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 90.44C47.46 90.55 47.31 90.67 47.22 90.57L28.76 72.06H28.74L24.25 67.52H32.45L22.32 49.21C22.26 49.1 22.41 48.98 22.5 49.08L40.9 67.52H40.92L45.41 72.06H37.24L47.4 90.43V90.44Z",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.95 27.03C76.76 16.95 67.79 9.39001 57.05 9.39001C47.23 9.39001 39.53 15.39 36.51 24.18L36.04 24.67C33.11 22.46 29.48 21.13 25.52 21.13C15.86 21.13 8.03 28.96 8.03 38.62C8.03 48.28 15.86 56.11 25.52 56.11H77.37C85.43 56.11 91.96 49.58 91.96 41.52C91.96 33.99 86.26 27.8 78.94 27.02L78.95 27.03Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.73 57.7C84.73 54.33 83.85 51.67 83.13 50.11C81.15 45.53 77.47 41.86 72.88 39.86C72.86 39.84 72.83 39.82 72.79 39.81C64.29 36 55.12 38.52 49.89 45.09H49.91C46.93 48.59 45.13 53.15 45.15 58.14C45.16 60.89 45.73 63.49 46.74 65.86C46.77 65.96 46.81 66.05 46.85 66.15C47.79 68.42 49.01 69.99 49.92 70.93C51.35 72.58 53.05 73.99 54.96 75.1C58.72 77.49 62.89 78.35 67.41 77.65C70.35 77.3 73.09 76.3 75.48 74.79C78.79 72.82 81.26 70.01 82.84 66.44C84.07 63.81 84.75 60.85 84.73 57.73V57.71V57.7Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7797 65.7952L57.0909 47.1063L54.1069 50.0903L72.7957 68.7791L75.7797 65.7952Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0948 68.7797L75.7836 50.0908L72.7996 47.1068L54.1108 65.7957L57.0948 68.7797Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.c08626df96b5f7512373f62652c48345.svg";
export { ForwardRef as ReactComponent };